import React, { useState, useEffect, useMemo } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

function DifferenceListModal(props) {
  const { priceListId, showDifferenceModal } = props;
  const [priceLists, setPriceLists] = useState([]);
  const [selectedList, setSelectedList] = useState();

  async function listPriceLists() {
    let res = await wsGetAll('logi/price-list');
    if (res.success) setPriceLists(res.data);
  }

  async function showModalDifferences() {
    showDifferenceModal(priceListId, selectedList);
  }

  useEffect(() => {
    listPriceLists();
  }, []);

  const validPriceLists = useMemo(() => {
    return priceLists.filter((list) => list.id !== parseInt(priceListId));
  }, [priceLists, priceListId]);

  return (
    <Modal
      title={`Diferencias de precios`}
      model={props.model}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      entity=""
      onSubmit={showModalDifferences}
      saveButtonLabel="Ver"
    >
      <Autocomplete
        options={validPriceLists}
        getOptionLabel={(item) => item.ListName}
        renderInput={(params) => (
          <TextField {...params} label="Lista de precio a comparar" margin="normal" required />
        )}
        value={selectedList || null}
        onChange={(_, list) => {
          if (list === null) return setSelectedList(undefined);
          setSelectedList(list);
        }}
      />
    </Modal>
  );
}

export default DifferenceListModal;
